webpackJsonpFeelterScript([0,2],{

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(AbstractMention, doT) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(2);

var _Store = __webpack_require__(0);

var _Templates = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetMentionTpl = _Store.actions.mergeTemplates(_Templates.WidgetMention, 'WidgetMention');
var NewWidgetMentionTpl = _Store.actions.mergeTemplates(_Templates.New_WidgetMention, 'WidgetMention');

var Mention = function (_AbstractMention) {
	_inherits(Mention, _AbstractMention);

	function Mention(MentionID, data, options) {
		_classCallCheck(this, Mention);

		var _this = _possibleConstructorReturn(this, (Mention.__proto__ || Object.getPrototypeOf(Mention)).call(this, MentionID, data, options));

		if (options.widgetOptions.newDesign || options.widgetOptions.newDesign2) {
			_this.Template = NewWidgetMentionTpl;
		} else {
			_this.Template = WidgetMentionTpl;
		}
		return _this;
	}

	_createClass(Mention, [{
		key: "AfterContentCreated",
		value: function AfterContentCreated(elm) {
			if (!elm) return;
			if (!this.contentObj.Elm) this.contentObj.Elm = elm;
			this.DetermineContentHeight(elm);
			if (elm.nextElementSibling) {
				var translateBtn = elm.closest('.mention').querySelector('.translate');
				if (translateBtn) {
					elm.closest('.body').insertBefore(translateBtn, elm.nextElementSibling);
				}
			}
		}
	}, {
		key: "render",
		value: function render() {
			var Tpl = this.Template.str;

			var data = {
				mentionID: this.MentionID,
				sourceID: this.Data.SourceID,
				classes: (0, _Utils.toInlineClasses)({
					animate: this.Options.animateMention.length > 0,
					animateVisible: this.MentionViewed
				}),
				hasLikes: this.Options.likes.show ? 'hasLikes' : '',
				components: {
					loader: this.Loader.render(),
					header: this.RenderMentionHeader(),
					body: this.RenderMentionBody(),
					translateBtn: this.RenderTranslateBtn(),
					moderation: this.Options.moderate ? this.RenderModerate() : '',
					likes: this.RenderMentionLikes()
				}
			};

			return doT.template(Tpl)(data);
		}
	}]);

	return Mention;
}(AbstractMention);

exports.default = Mention;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)["default"], __webpack_require__(1)))

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Product, SimpleBar, doT) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Mention = __webpack_require__(20);

var _Mention2 = _interopRequireDefault(_Mention);

var _Store = __webpack_require__(0);

var _Templates = __webpack_require__(3);

var _EventBus = __webpack_require__(6);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _GAEvents = __webpack_require__(4);

var _Utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetTpl = _Store.actions.mergeTemplates(_Templates.Widget, 'Carousel');
var NewWidgetTpl = _Store.actions.mergeTemplates(_Templates.Widget_NW, 'Carousel');
var NewWidgetTpl2 = _Store.actions.mergeTemplates(_Templates.Widget_NW2, 'Carousel');
var AWidgetTpl = _Store.actions.mergeTemplates(_Templates.Aspects_Widget, 'Carousel');
var Aspects = _Store.actions.mergeTemplates(_Templates.Aspects, 'Carousel');

var Widget = function (_Product) {
	_inherits(Widget, _Product);

	function Widget(kpData, options, appEvents) {
		_classCallCheck(this, Widget);

		var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this, kpData, options, _Mention2.default, appEvents));

		_this.IsOpen = false;
		_this.ShownOnce = false;

		if (options.widgetOptions.newDesign) {
			_this.Template = NewWidgetTpl;
		} else if (options.widgetOptions.newDesign2) {
			_this.Template = NewWidgetTpl2;
		} else {
			_this.Template = WidgetTpl;
		}

		if (options.widgetOptions.aspects_widget) _this.Template = AWidgetTpl;
		if (options.widgetOptions.aspects) _this.Template = Aspects;

		_this.isAutoPlay = options.autoplay;
		_this.AppEvents.subscribe("anchorClicked", function (e, data) {
			//console.log('ee',e)
			//consol e.log('data',data)
			//if (options.widgetOptions.newDesign2)	e.stopPropagation();
			_this.openWidget();
		});
		// if (options.widgetOptions.newDesign2) this.AppEvents.subscribe("ratingsAnchorClicked", (e, data) => {

		// 	this.openWidget();
		// });

		var renderWidgetMentions = function renderWidgetMentions(e, AppElm) {
			var productElm = AppElm.querySelector(".productElm");
			_this.AfterCreate(productElm);

			_this.RenderMentions().then(function () {
				if (options.autoplay) {
					_this.QueuedToPlay = _this.Mentions[0];
					_this.PlayQueued();
				}
				_this.InitWidgetScroll();
			});
		};
		_this.AppEvents.subscribe("appUpdated", renderWidgetMentions);

		_EventBus2.default.$on("widgetBackClicked", function (e) {
			_this.closeWidget();
		});

		_this.AppEvents.subscribe("mainJsonLoaded", function (e, KpData) {
			_this.KpData = KpData;
			_this.MentionsData = KpData.Data;
			_this.SetMentions(KpData.Mentions);

			// this.setMentionsWrapperHeight();
			renderWidgetMentions(e, _this.AppElm);
			_this.boundaries = _this.Elm.getBoundingClientRect();
		});
		return _this;
	}

	_createClass(Widget, [{
		key: 'AfterCreate',
		value: function AfterCreate(elm) {
			var _this2 = this;

			if (!this.Elm) {
				this.AppElm = elm.closest('.' + this.AppClass);

				this.DragZone = this.AppElm.querySelector('.dragZone');
				if (this.DragZone && !(0, _Utils.isMobile)()) this.bindDrag();

				this.closeBtn = this.AppElm.querySelector('.close_widget');
				this.closeBtn.onclick = function () {
					_this2.closeWidget();
				};

				this.setWidgetStyle();
			}

			this.Elm = elm;
		}
	}, {
		key: 'bindDrag',
		value: function bindDrag() {
			var _this3 = this;

			var moveWidget = (0, _Utils.throttle)(function (e) {
				e.stopPropagation();

				if (isDragging && e.clientX !== 0 && e.clientX !== lastClientX && e.clientY !== 0 && e.clientY !== lastClientY) {
					offsetX = e.clientX - dragStartX;
					offsetY = e.clientY - dragStartY;
					lastClientX = e.clientX;
					lastClientY = e.clientY;
					_this3.AppElm.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px)';
				}
			}, 50);

			function stopDragging() {
				if (!isDragging) return; // Exit if not dragging

				isDragging = false;
				this.widgetBack.removeEventListener("mousemove", moveWidget);
				this.Elm.removeEventListener("mousemove", moveWidget);
				this.PlayQueued();
			}

			var isDragging = false;
			var dragStartX = void 0,
			    dragStartY = void 0,
			    offsetX = 0,
			    lastClientX = void 0,
			    offsetY = 0,
			    lastClientY = void 0;

			this.DragZone.addEventListener("mousedown", function (e) {
				dragStartX = e.clientX - offsetX;
				dragStartY = e.clientY - offsetY;
				isDragging = true;

				// Stop current playing video to improve visual performance.
				_this3.StopAndQueueToPlay();

				// Add event listener when the mouse is moving too quick outside the dragging zone into the below elements123.
				_this3.widgetBack.addEventListener("mousemove", moveWidget);
				_this3.Elm.addEventListener("mousemove", moveWidget);
			});

			this.DragZone.addEventListener("mouseup", function (e) {
				stopDragging.call(_this3);
			});

			this.DragZone.addEventListener("mousemove", moveWidget);

			document.addEventListener("keydown", function (e) {
				if (e.key === "Escape" || e.keyCode === 27) {
					stopDragging.call(_this3);
				}
			}, true);

			// Ensure multiple listeners aren't set
			if (!this._initializedDragListeners) {
				// Listen to mouseup on the entire document:
				document.addEventListener("mouseup", function (e) {
					stopDragging.call(_this3);
				});

				// Listen to mouse out on the entire document
				document.addEventListener("mouseout", function (e) {
					// Check if we're actually leaving the document
					if (!e.relatedTarget && !e.toElement) {
						stopDragging.call(_this3);
					}
				});

				this._initializedDragListeners = true; // Set flag to indicate listeners are set
			}
		}
	}, {
		key: 'setWidgetStyle',
		value: function setWidgetStyle() {
			if (!this.anchorElm) {
				this.setWidgetStyle();
				return;
			}

			var options = this.Options.widgetOptions;
			var widgetWidth = options.width;
			var widgetHeight = options.height;
			var windowHeight = window.innerHeight;
			this.anchorBoundaries = this.anchorElm.getBoundingClientRect();

			if (windowHeight < widgetHeight) widgetHeight = windowHeight;

			var widgetTop = (windowHeight - widgetHeight) / 2 + window.pageYOffset + options.offsetTop;

			// if the widget bottom offset is lower than the window bottom,
			// pin it to limit bottom of the window for not making over scroll space.
			if (document.body.scrollHeight < widgetTop + widgetHeight) {
				widgetHeight = windowHeight;
				widgetTop = document.body.scrollHeight - widgetHeight;
			}

			var widgetLeft = 0;
			var widgetTransform = "none";

			if (options.position === "center") {
				widgetLeft = "50%";
				widgetTransform = "translateX(-50%)";
			} else {
				widgetLeft = this.anchorBoundaries.left + window.pageXOffset + this.anchorBoundaries.width + -1 * options.offsetRight;
				// if there is no room for the widget from the anchor right open it from the anchor's left.
				var offsetLeftFix = 80; // adding 80px offset so the widget won't be too close to the end of the screen.
				if (widgetLeft + widgetWidth + offsetLeftFix > window.innerWidth) {
					widgetLeft = this.anchorBoundaries.left - widgetWidth + options.offsetRight;
				}
				widgetLeft += "px";
			}

			this.AppElm.style.width = widgetWidth + "px";
			this.AppElm.style.height = widgetHeight + "px";
			this.AppElm.style.top = widgetTop + "px";
			this.AppElm.style.left = widgetLeft;
			this.AppElm.style.transform = widgetTransform;
			if (this.Options.referrer === 'widget-new-goglobal.co.il') {
				var sourceEl = document.querySelector('.fl_app'); // the element you want to measure
				//const targetEl =this.AppElm; // the one you�ll move

				// 2. Get its distance from the top of the *document*
				var sourceRect = this.anchorElm.getBoundingClientRect();
				var scrollY = window.pageYOffset || document.documentElement.scrollTop;
				var sourceTop = sourceRect.top + scrollY;

				this.AppElm.querySelector('.fl_app').style.top = sourceTop + 'px';
			}
		}
	}, {
		key: 'openWidget',
		value: function openWidget() {
			var _this4 = this;

			var anchorBoundaries = this.anchorElm.getBoundingClientRect();
			if (this.anchorBoundaries && (anchorBoundaries.top !== this.anchorBoundaries.top || anchorBoundaries.left !== this.anchorBoundaries.left)) {
				this.setWidgetStyle();
			}

			if (!this.widgetBack) this.widgetBack = document.querySelector('.fl_widget_back');
			this.widgetBack.style.display = 'block';

			if (!this.ShownOnce) {
				(0, _GAEvents.reportGAEvents)('interacted', this.KeyPhrase);
			}

			// if the widget is first time inserted to the page we need to wait 200ms for the html to be rendered
			this.AppElm.className += " active";
			this.IsOpen = true;

			(0, _GAEvents.reportGAEvents)('show', this.Phrase);

			var scoreElm = this.AppElm.querySelector(".appHeader .score");
			scoreElm.className += ' animate-pop';
			setTimeout(function () {
				scoreElm.className = scoreElm.className.replace(' animate-pop', '');
			}, 500);

			setTimeout(function () {
				if (!_this4.ShownOnce) {
					(0, _GAEvents.reportGAEvents)('shown once', _this4.Phrase);
					_this4.ShownOnce = true;
				} else {
					// Play the last paused video when the widget was closed.
					// first let the score animation finish from visual performance aspects.
					setTimeout(function () {
						_this4.PlayQueued();
					}, 800);
				}
			}, 100);
		}
	}, {
		key: 'closeWidget',
		value: function closeWidget() {
			if (!this.IsOpen) return;
			this.widgetBack.style.display = 'none';
			this.AppElm.className = this.AppElm.className.replace("active", "");
			this.IsOpen = false;

			// pause all videos when the widget is closed.
			this.StopAndQueueToPlay();
		}
	}, {
		key: 'InitWidgetScroll',
		value: function InitWidgetScroll() {
			var _this5 = this;

			this.Scroller = new SimpleBar(this.Elm, {
				scrollbarMinSize: 40
			});

			if (this.isAutoPlay) {
				this.Scroller.getScrollElement().addEventListener('scroll', (0, _Utils.throttle)(function (e) {
					var visibleVideos = {};
					_this5.Mentions.forEach(function (mention) {
						if (!mention.Elm) return;
						var mentionBoundaries = mention.Elm.getBoundingClientRect();

						var hiddenPercentage = Math.round(Math.abs(mentionBoundaries.top - _this5.boundaries.top) / mentionBoundaries.height * 100);
						mention.HiddenPercentage = hiddenPercentage;
						mention.IsVisible = hiddenPercentage >= 0 && hiddenPercentage < 80;
						if (mention.IsVisible && mention.hasVideo) {
							visibleVideos[hiddenPercentage] = mention;
						} else if (!mention.IsVisible && mention.Player) {
							mention.Player.pause();
						}
					});

					var videoPlayed = false;
					for (var percent in visibleVideos) {
						var mention = visibleVideos[percent];
						if (!videoPlayed) {
							// play the video only if it didn't initialize or
							// if it's not already playing or the video has ended.
							if (!mention.Player || mention.Player && !mention.Player.IsPlaying) mention.AutoplayVideos();
							videoPlayed = true;
						} else if (videoPlayed && mention.Player) {
							mention.Player.pause();
						}
					}
				}, 1000));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var Tpl = this.Template.str;
			var data = {
				components: {
					mentions: []
				}
			};

			return doT.template(Tpl)(data);
		}
	}, {
		key: 'AppClass',
		get: function get() {
			return "fl_widget";
		}
	}, {
		key: 'Mentions',
		get: function get() {
			return this._mentions || [];
		},
		set: function set(newVal) {
			if (newVal !== this._mentions) {
				this._mentions = newVal;
			}
		}
	}]);

	return Widget;
}(Product);

exports.default = Widget;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)["default"], __webpack_require__(22), __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// chunks/0.feelter.min.js